import React from 'react';
import { Heart, Sparkles, MapPin, Clock } from 'lucide-react';

interface HomeProps {
  onStartPlanning: () => void;
}

export default function Home({ onStartPlanning }: HomeProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-rose-50 via-pink-50 to-white">
      {/* Header */}
      <div className="pt-8 pb-12 px-4 text-center">
        <div className="inline-block mb-4 p-3 bg-rose-100 rounded-full">
          <Heart size={32} className="text-rose-600" />
        </div>
        <h1 className="text-4xl font-bold text-slate-900 mb-2">
          Plan Our <span className="text-rose-600">Date</span>
        </h1>
        <p className="text-slate-600 text-lg">
          Create unforgettable moments in Kolkata
        </p>
      </div>

      {/* Feature Cards */}
      <div className="px-4 space-y-3 mb-8">
        <div className="card-interactive group">
          <div className="flex gap-3">
            <div className="p-2 bg-rose-100 rounded-lg h-fit group-hover:bg-rose-200">
              <MapPin size={20} className="text-rose-600" />
            </div>
            <div>
              <h3 className="font-semibold text-slate-900">Smart Routing</h3>
              <p className="text-sm text-slate-600">
                Multi-stop itineraries that flow perfectly
              </p>
            </div>
          </div>
        </div>

        <div className="card-interactive group">
          <div className="flex gap-3">
            <div className="p-2 bg-blue-100 rounded-lg h-fit group-hover:bg-blue-200">
              <Clock size={20} className="text-blue-600" />
            </div>
            <div>
              <h3 className="font-semibold text-slate-900">Perfect Timing</h3>
              <p className="text-sm text-slate-600">
                Exactly fits your available time
              </p>
            </div>
          </div>
        </div>

        <div className="card-interactive group">
          <div className="flex gap-3">
            <div className="p-2 bg-amber-100 rounded-lg h-fit group-hover:bg-amber-200">
              <Sparkles size={20} className="text-amber-600" />
            </div>
            <div>
              <h3 className="font-semibold text-slate-900">No Repeats</h3>
              <p className="text-sm text-slate-600">
                Never suggest places you've already done
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="px-4 mb-12">
        <div className="grid grid-cols-3 gap-4">
          <div className="card text-center">
            <div className="text-2xl font-bold text-rose-600">18+</div>
            <p className="text-xs text-slate-600">Unique Places</p>
          </div>
          <div className="card text-center">
            <div className="text-2xl font-bold text-rose-600">100+</div>
            <p className="text-xs text-slate-600">Route Ideas</p>
          </div>
          <div className="card text-center">
            <div className="text-2xl font-bold text-rose-600">∞</div>
            <p className="text-xs text-slate-600">Memories</p>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="fixed bottom-24 left-0 right-0 px-4">
        <button
          onClick={onStartPlanning}
          className="w-full btn-primary flex items-center justify-center gap-2 py-4 text-lg"
        >
          <Sparkles size={24} />
          Build Our Date
        </button>
        <p className="text-center text-sm text-slate-500 mt-3">
          ❤️ Make every moment count
        </p>
      </div>

      {/* Footer */}
      <div className="h-32"></div>
    </div>
  );
}
